import { useEffect, useState } from 'react';
import { HeaderPageCobranca } from '../../components/HeaderPageCobranca';
import { TabelaCobranca } from '../../components/TabelaCobrancas';
import { useGlobal } from '../../hooks/useGlobal';

export function Cobranca() {
  const { setHeaderText,goTo } = useGlobal();

  useEffect(() => {
    setHeaderText(3);
    goTo(2);
  })
  return (
    <>
      <HeaderPageCobranca />
      <TabelaCobranca />
    </>
  );
};
